import { render, staticRenderFns } from "./SalesReturn.vue?vue&type=template&id=15e7684e&"
import script from "./SalesReturn.vue?vue&type=script&lang=js&"
export * from "./SalesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports